import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import ResumeDownload from './ResumeDownload';

export interface TopNavbarProps { }

const TopNavbar: React.FC<TopNavbarProps> = () => {
    const { language, toggleLanguage, t } = useLanguage();

    return (
        <header>
            <div className="ancho">
                <div className="logo">
                    <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                        <p>
                            <strong>Jose</strong>Eduardo
                        </p>
                    </Link>
                </div>
                <nav className="menu-ppl">
                    <ul>
                        <li>
                            <Link to="/">{t('nav_about')}</Link>
                            <Link to="/experience">{t('nav_experience')}</Link>
                            <Link to="/projects">{t('nav_projects')}</Link>
                            <Link to="/contact">{t('nav_contact')}</Link>
                        </li>
                    </ul>
                </nav>
                <div className="redes">
                    <ul>
                        <li>
                            <a
                                target="_blank"
                                href="https://github.com/eduartdeveloper"
                                rel="noreferrer"
                                aria-label="GitHub Profile"
                                title="GitHub"
                            >
                                <i className="fa fa-github" aria-hidden="true"></i>
                            </a>
                            <a
                                href="https://www.linkedin.com/in/jose-eduardo-rendon-valencia-362329221/"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="LinkedIn Profile"
                                title="LinkedIn"
                            >
                                <i className="fa fa-linkedin" aria-hidden="true"></i>
                            </a>
                            <a
                                href="mailto:gmail@joseeduardo.com.co"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Email Contact"
                                title="Email"
                            >
                                <i className="fa fa-envelope-o" aria-hidden="true"></i>
                            </a>
                            <a
                                target="_blank"
                                href="https://wa.me/573133185893"
                                rel="noreferrer"
                                aria-label="WhatsApp Contact"
                                title="WhatsApp"
                            >
                                <i className="fa fa-whatsapp" aria-hidden="true"></i>
                            </a>
                            <a
                                target="_blank"
                                href="https://www.instagram.com/___eduart___/"
                                rel="noreferrer"
                                aria-label="Instagram Profile"
                                title="Instagram"
                            >
                                <i className="fa fa-instagram" aria-hidden="true"></i>
                            </a>
                            <ResumeDownload variant="pill" />
                            <button
                                className="lang-toggle-btn"
                                onClick={toggleLanguage}
                                title={language === 'es' ? 'Cambiar a Inglés' : 'Switch to Spanish'}
                                aria-label="Toggle language"
                            >
                                {language === 'es' ? 'EN' : 'ES'}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    );
};

export default TopNavbar;
